import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/edit-tool.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pie-chart.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/bottom-mobile-buttons.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/cagr-graph.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/faq-section.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/price_breakUp_btn.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/report-page/report-breadcrumb.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/report-title-section.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/sample-button.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/scrollspy.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/share-button.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/tarrif-banner.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/report-page/toc-section/toc-sections.jsx");
